import { useState } from "react";
import PrecalificacionForm from "@/components/agenda/PrecalificacionForm";
import CalendlyEmbed from "@/components/agenda/CalendlyEmbed";

const Agenda = () => {
  const [qualified, setQualified] = useState<null | boolean>(null);

  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-20 bg-white">
      <div className="max-w-2xl w-full">
        {qualified === null && (
          <>
            <h1 className="text-3xl font-semibold text-gray-800 mb-6">
              Agenda un diagnóstico energético
            </h1>
            <p className="text-gray-600 mb-8">
              Para asegurar una evaluación adecuada, necesitamos validar algunos
              datos antes de agendar la reunión.
            </p>

            <PrecalificacionForm onQualify={setQualified} />
          </>
        )}

        {qualified === true && (
          <>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Perfecto, podemos evaluar tu caso
            </h2>
            <p className="text-gray-600 mb-6">
              Agenda una reunión con nuestro equipo técnico-comercial.
            </p>

            <CalendlyEmbed />
          </>
        )}

        {qualified === false && (
          <>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Gracias por tu interés
            </h2>
            <p className="text-gray-600 mb-6">
              Actualmente nuestras soluciones están enfocadas en empresas con
              mayor consumo eléctrico.
            </p>

            <a
              href="https://wa.me/51XXXXXXXXX"
              className="inline-block mt-4 px-6 py-3 rounded-xl font-medium text-white"
              style={{ backgroundColor: "#F28C00" }}
            >
              Escríbenos por WhatsApp
            </a>
          </>
        )}
      </div>
    </main>
  );
};

export default Agenda;
